import { Select, Card, Tooltip } from 'antd'

// assets
import { FaNoteSticky } from 'react-icons/fa6'
import NoProfile from '../../../assets/images/no_profile.png'

// constants
import { JOB_APPLICATIONS_STATUS } from '../../../constants/jobs'

import { FaPhoneAlt } from 'react-icons/fa'
import { FaLocationDot } from 'react-icons/fa6'

const JobApplicantInfoCard = ({
    state,
    handleUpdateJobApplicationStatus,
    handleViewNotes,
}) => {
    return (
        <>
            <Card>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                        }}
                    >
                        <div>
                            <img
                                src={
                                    state?.selectedApplicantData
                                        ?.profilePicture || NoProfile
                                }
                                alt="Profile"
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                            }}
                        >
                            <h3
                                style={{
                                    margin: 0,
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: '#252525',
                                }}
                            >
                                {state?.selectedApplicantData?.fullName || '—'}
                                &nbsp;
                                {state?.selectedApplicantData?.candidate
                                    ?.designation &&
                                    `(${
                                        state?.selectedApplicantData?.candidate
                                            ?.designation?.name || '—'
                                    })`}
                            </h3>

                            <span style={{ fontSize: '14px', color: '#555' }}>
                                {state?.selectedApplicantData?.candidate
                                    ?.experience?.length > 0 && (
                                    <>
                                        {
                                            state?.selectedApplicantData
                                                ?.candidate?.experience[0]
                                                ?.company?.name
                                        }{' '}
                                        (
                                        {new Date(
                                            state?.selectedApplicantData?.candidate?.experience[0]?.startDate
                                        ).getFullYear()}
                                        {' - '}
                                        {state?.selectedApplicantData?.candidate
                                            ?.experience[0]?.currentlyWorking
                                            ? 'Present'
                                            : new Date(
                                                  state?.selectedApplicantData?.candidate?.experience[0]?.endDate
                                              ).getFullYear()}
                                        )
                                    </>
                                )}
                                {state?.selectedApplicantData?.candidate
                                    ?.education?.length > 0
                                    ? ` • ${state?.selectedApplicantData?.candidate?.education[0]?.institute?.name}`
                                    : ''}
                            </span>

                            <div
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                    flexWrap: 'wrap',
                                    marginTop: '4px',
                                }}
                            >
                                {state?.selectedApplicantData?.candidate
                                    ?.address && (
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '13px',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            background: '#f3f4f6',
                                            color: '#374151',
                                        }}
                                    >
                                        <FaLocationDot />

                                        {
                                            state?.selectedApplicantData
                                                ?.candidate?.address
                                        }
                                    </span>
                                )}

                                {state?.selectedApplicantData?.candidate
                                    ?.primaryContactNumber && (
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '13px',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            background: '#f3f4f6',
                                            color: '#374151',
                                        }}
                                    >
                                        <FaPhoneAlt />

                                        {`${
                                            state?.selectedApplicantData
                                                ?.candidate
                                                ?.primaryContactNumberCountryCode ||
                                            ''
                                        } ${
                                            state?.selectedApplicantData
                                                ?.candidate
                                                ?.primaryContactNumber
                                        }`}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            flexDirection: 'column',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                gap: '10px',
                                marginBottom: '20px',
                                alignItems: 'center',
                            }}
                        >
                            {handleViewNotes && (
                                <Tooltip title="View Notes">
                                    <FaNoteSticky
                                        onClick={handleViewNotes}
                                        color="#4F46E5"
                                        size={24}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </Tooltip>
                            )}

                            {/* {handleViewAndUpdateResume && (
                                <span
                                    style={{
                                        border: '1px solid #C9C9C9',
                                        borderRadius: '5px',
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        padding: '9px 13px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={handleViewAndUpdateResume}
                                >
                                    Resume <RightArrow />
                                </span>
                            )} */}

                            {handleUpdateJobApplicationStatus && (
                                <span>
                                    <Select
                                        placeholder="Select a Status"
                                        onChange={(event) => {
                                            handleUpdateJobApplicationStatus(
                                                event
                                            )
                                        }}
                                        className="recruitStatusSelect"
                                        style={{
                                            padding: '0px 0px',
                                        }}
                                        value={
                                            state?.selectedApplicantData
                                                ?.applicationStatus
                                        }
                                        options={JOB_APPLICATIONS_STATUS}
                                    />
                                </span>
                            )}
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                marginBottom: '8px',
                            }}
                        >
                            <span
                                style={{ color: '#4F46E5', fontSize: '16px' }}
                            >
                                Expected
                            </span>
                            <span>
                                <span
                                    style={{
                                        fontSize: '22px',
                                        fontWeight: 700,
                                    }}
                                >
                                    $
                                    {state?.selectedApplicantData?.candidate
                                        ?.expectedSalary || 0}{' '}
                                    /{' '}
                                </span>
                                <span
                                    style={{
                                        fontSize: '16px',
                                        fontWeight: 400,
                                    }}
                                >
                                    {state?.selectedApplicantData?.candidate
                                        ?.expectedSalaryType || '-'}
                                </span>
                            </span>
                        </div>

                        <div style={{ fontWeight: 300, fontSize: '16px' }}>
                            <span>Available From : </span>
                            <span style={{ color: '#747474' }}>
                                {
                                    state?.selectedApplicantData?.candidate
                                        ?.availableFrom
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}

export default JobApplicantInfoCard
